<template>
	<div class="login-wrap" @keyup.enter="login">
		<div class="login_window" v-if="user.institutionId!=1">
			<div class="login_window_back"></div>
			<div class="login_window_content">
				<label class="title">后台管理系统</label>
				<el-form class="login_window_form" :model="user" :rules="rules" ref="ruleForm" :label-position="labelPosition" label-width="80px">
					<el-form-item label="用户账号" prop="account"><el-input v-model="user.account"></el-input></el-form-item>
					<el-form-item label="用户密码" prop="password"><el-input type="password" v-model="user.password"></el-input></el-form-item>
					<el-button type="primary" class="btn" @click="handleLogin">登录</el-button>
				</el-form>
			</div>
		</div>
		<div class="login_window" v-else style="height:450px">
			<div class="login_window_back"></div>
			<div class="login_window_content">
				<label class="title">后台管理系统</label>
				<el-form class="login_window_form" :model="user" :rules="rules" ref="ruleForm" :label-position="labelPosition" label-width="80px">
					<el-form-item label="用户账号" prop="account"><el-input v-model="user.account"></el-input></el-form-item>
					<el-form-item label="用户密码" prop="password"><el-input type="password" v-model="user.password"></el-input></el-form-item>
					<el-form-item label="手机号" prop="phone"><el-input type="phone" v-model="user.phone"></el-input></el-form-item>
					<el-form-item label="验证码" prop="code">
						<el-input style="width:100px;float:left" type="code" v-model="user.code"></el-input>
						<el-button style="float:left;margin-top: 12px;margin-left: 5px;" type="primary" size="mini" :loading="loading" :disabled="countdown > 0"
							@click="getVerificationCode">{{buttonText}}</el-button>
					</el-form-item>
					<el-button type="primary" class="btn" @click="handleLogin">登录</el-button>
				</el-form>
			</div>
		</div>

		<!-- 提示框 -->
		<el-dialog title="提示" :visible.sync="dialogVisible" width="300px" :before-close="handleClose">
			<span>{{ message }}</span>
			<span slot="footer" class="dialog-footer"><el-button type="primary" @click="dialogVisible = false">确 定</el-button></span>
		</el-dialog>
	</div>
</template>

<script>
	import subSelect from '@/components/layout/sub-select';
	import common from '@/common/common.js';
	export default {
		components: {
			subSelect
		},
		data() {
			return {
				labelPosition: 'right',
				message: '',
				dialogVisible: false,
				dialogAddTimeVisible: false,
				addTimeForm: {},
				code: "",
				countdown: 0,
				timer: null,
				loading:false,
				user: {
					account: '',
					password: '',
					institutionId: ""
				},
				rules: {
					account: [{
						required: true,
						message: '用户账号不能为空',
						trigger: 'change'
					}],
					cardNo: [{
						required: true,
						message: '卡号不能为空',
						trigger: 'change'
					}],
					password: [{
						required: true,
						message: '用户密码不能为空',
						trigger: 'change'
					}],
					phone: [{
						required: true,
						message: '请输入手机号',
						trigger: 'change'
					}, {
						pattern: /^1\d{10}$/,
						message: '请输入正确的手机号',
						trigger: 'blur'
					}],
					code: [{
						required: true,
						message: '请输入验证码',
						trigger: 'change'
					}]
				}
			};
		},
		computed: {
			buttonText() {
				return this.countdown > 0 ? `${this.countdown}秒后重新获取` : '获取验证码'
			}
		},
		created: function() {},
		methods: {
			isValidPhone(phone) {
				return /^1\d{10}$/.test(phone);
			},
			getVerificationCode() {
				this.$refs['ruleForm'].clearValidate();
				this.$refs['ruleForm'].validateField('phone', (errorMessage) => {
					if (!errorMessage) {
						this.loading=true
						this.$http({
							method: 'POST',
							url: 'sendSms',
							data: this.user
						}).then((res) => {
							this.loading=false
							if (res.data.errorCode == '0000') {
								this.countdown = 60;
								this.timer = setInterval(() => {
									this.countdown--;
									if (this.countdown <= 0) {
										clearInterval(this.timer);
									}
								}, 1000);
							}
						})
					}
				})
			},
			beforeDestroy() {
				// 组件销毁前清除定时器
				if (this.timer != null) {
					clearInterval(this.timer);
				}
			},
			handleAdddTime() {
				if (this.$refs.addTimeForm != undefined) {
					this.$refs['addTimeForm'].resetFields();
				}
				this.addTimeForm.confirm = false;
				this.dialogAddTimeVisible = true;
			},
			handleLogin() {
				// 登录
				this.$refs['ruleForm'].validate(valid => {
					if (valid) {
						// 加载动画
						const loading = this.$loading({
							lock: true,
							text: '登录中, 请稍等...',
							spinner: 'el-icon-loading',
							background: 'rgba(0, 0, 0, 0.7)'
						});

						let that = this;
						if (this.user.institutionId) {
							this.login(loading);
						} else {
							this.$http({
								method: 'POST',
								url: 'institution/getId?code=' + this.code,
								data: null
							}).then((res) => {
								if (!res.data.data) {
									this.$router.push('/404');
								}
								this.user.institutionId = res.data.data;
								this.login(loading);
							})

						}
					} else {
						return false;
					}
				});
			},
			login(loading) {
				let that = this;
				this.$http({
					method: 'POST',
					url: 'login',
					data: this.user,
					error: function(res) {
						loading.close();
						that.message = res.data.message;
						that.dialogVisible = true;
					}
				}).then((res) => {
					if (res.data.errorCode == '0000') {
						sessionStorage.setItem('institutionCode', this.code);
						sessionStorage.setItem('token', res.data.data.token);
						sessionStorage.setItem('_userName', res.data.data.realName);
						sessionStorage.setItem('_userId', res.data.data.userId);
						sessionStorage.setItem('_roleName', res.data.data.roleName);
						sessionStorage.setItem('_roleId', res.data.data.roleId);
						sessionStorage.setItem('_institutionId', res.data.data.institutionId);
						loading.close();
						common.routerPush(this, '/home')
					}
				})
			},
			successMessage(title, msg) {
				//成功提示
				this.$notify({
					title: title,
					message: msg,
					type: 'success'
				});
			},
			errorMessage(title, msg) {
				//失败提示
				this.$notify.error({
					title: title,
					message: msg,
					type: 'success'
				});
			},
			handleClose(done) {
				this.dialogVisible = false;
			},
			keyDownSearch(e) {
				// 兼容FF和IE和Opera
				var theEvent = e || window.event;
				var code = theEvent.keyCode || theEvent.which || theEvent.charCode;
				if (code == 13) {
					this.handleLogin();
					return false;
				}
				return true;
			},
			changeFavicon(iconPath) {
				const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
				link.type = 'image/x-icon';
				link.rel = 'shortcut icon';
				link.href = iconPath;
				document.getElementsByTagName('head')[0].appendChild(link);
			},
			getInstitution(code) {
				this.$http({
					method: 'GET',
					url: 'institution/detail2?code=' + code,
				}).then((res) => {
					if (!res.data.data) {
						this.$router.push('/404');
					} else {
						this.user.institutionId = res.data.data.id;
						if (res.data.data.logo) {
							this.changeFavicon(res.data.data.logo);
						}
					}
				})
			}
		},
		beforeMount: function() {
			this.code = this.$route.params.code
			this.getInstitution(this.$route.params.code);
			document.onkeydown = this.keyDownSearch;
			var token = sessionStorage.getItem('token');
			if (token) {
				var oldCode = sessionStorage.getItem('institutionCode');
				if (oldCode == this.code) {
					common.routerPush(this, '/home')
				}
			} else {
				if (this.$route.query.errorMessage) {
					alert(this.$route.query.errorMessage);
				}
			}
			this.$router.replace({
				path: this.$route.path, // 当前路径（如 '/703704707/login'）
				query: {} // 清空所有 query 参数
			});
		}
	};
</script>

<style>
	.login-wrap .login_window .el-form-item__label {
		color: #ffffff;
	}

	.login-wrap .login_window .el-input__inner {
		border-top-width: 0px;
		border-left-width: 0px;
		border-right-width: 0px;
		border-bottom-width: 1px;
		background-color: transparent;
		border-radius: 0px;
		color: #ffffff;
		/*outline: medium;*/
	}
</style>
<style rel="stylesheet/scss" lang="scss" scoped>
	.login-wrap {
		background: url(../../assets/img/timg.jpg);
		background-size: 100% 100%;
		width: 100%;
		height: 100vh;
		float: left;
		min-width: 500px;

		.login_window {
			width: 450px;
			height: 330px;
			margin: auto;
			margin-top: 12%;
			position: relative;

			.login_window_back {
				width: 100%;
				height: 100%;
				position: absolute;
				background: #1a1a1a;
				-moz-opacity: 0.24;
				opacity: 0.24;
				z-index: 1;
			}

			.login_window_content {
				z-index: 2;
				position: absolute;
				width: 100%;
				height: 100%;
				text-align: center;
				padding-top: 20px;

				.title {
					font-size: 16px;
					font-weight: 800;
					color: #ffffff;
					width: 100%;
					height: 50px;
					font-size: 20px;
					text-align: center;
					line-height: 50px;
				}

				input {
					border-left-width: 0px;
					border-top-width: 0px;
					border-right-width: 0px;
					border-bottom-color: black;
				}

				.login_window_form {
					padding: 40px 40px 00px 40px;
					color: #ffffff;

					.btn {
						width: 100%;
						float: right;
						height: 46px;
						font-size: 17px;
						color: #ffffff;
						margin-top: 20px;
					}
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/view/base/login.vue